import { ReportError } from '@app/core/reports/report-error';
import { DateTime } from 'luxon';
import { GipReportValues } from '../form/types';
import { areDatesDisabledForReport } from './helpers';

/** Maximum `from`–`to` span (in fractional days) allowed for GIP preview and export. */
export const GIP_REPORT_MAX_DATE_RANGE_DAYS = 90;

/**
 * Ensures the `from`–`to` interval does not exceed `maxDays` (Luxon duration in days).
 * Skips validation when the form hides or fixes the date range for this configuration.
 */
export function assertGipReportDateRangeWithinDays(
  values: GipReportValues,
  maxDays: number,
  rangeExceededMessage: string,
) {
  if (areDatesDisabledForReport(values)) {
    return;
  }

  const from = DateTime.fromISO(values.from);
  const to = DateTime.fromISO(values.to);
  if (!from.isValid || !to.isValid) {
    return;
  }

  const spanDays = to.diff(from).as('days');
  if (spanDays > maxDays) {
    throw new ReportError(rangeExceededMessage);
  }
}
